import { render } from "./FilterDropdown.vue?vue&type=template&id=60cc01d8&scoped=true&ts=true"
import script from "./FilterDropdown.vue?vue&type=script&lang=ts"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts"

import "./FilterDropdown.vue?vue&type=style&index=0&id=60cc01d8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cc01d8"]])

export default __exports__